import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router';
import { type QueryClient } from '@tanstack/react-query';

import { routes } from '#apps/client-web/app/routes';
import { type AuditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { useLoadAuditFormByType } from '#apps/client-web/features/audit-form/hooks/use-load-audit-form-by-type-query';

import { type LoggingContext } from '#packages/data-collection/types/logging-context';
import { type AuditId } from '#packages/data-collection/models/audit';
import { type AuditMechanicalForm } from '#packages/data-collection/models/audit-mechanical-form';

export type AuditFormMechanicalPageViewModel = ReturnType<
  typeof useAuditFormMechanicalPageViewModel
>;

type AuditFormMechanicalPageViewModelProps = LoggingContext & {
  auditFormService: AuditFormService;
  queryClient: QueryClient;
};

export const useAuditFormMechanicalPageViewModel = ({
  logger,
  auditFormService,
  queryClient,
}: AuditFormMechanicalPageViewModelProps) => {
  const { auditId } = useParams<{ auditId: AuditId }>();
  const navigate = useNavigate();

  const auditFormQuery = useLoadAuditFormByType<AuditMechanicalForm>({
    auditId: auditId!,
    queryClient,
    formType: 'mechanical',
    auditFormService,
  });

  const onCreate = useCallback(() => {
    logger?.info('Navigating to create audit mechanical form entry page');
    navigate(routes.audit.getEnergyAuditMechanicalFormEntryPath(auditId!, -1));
  }, [navigate]);

  return {
    auditId,
    auditFormQuery,

    onCreate,
  };
};
